import { useLang } from "@/lib/i18n";

/**
 * The site's one language switch, wearing the guide's own clothes: two slots in
 * one pill, the language you are reading in filled with the brand red, the other
 * left on paper. The island's flag sits beside the label so the choice reads as
 * Spanish/English rather than two anonymous letters.
 */
const FLAG =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 42'%3E%3Crect width='60' height='42' fill='%23ffffff'/%3E%3Cg fill='%23c8102e'%3E%3Crect width='60' height='8.4'/%3E%3Crect y='16.8' width='60' height='8.4'/%3E%3Crect y='33.6' width='60' height='8.4'/%3E%3C/g%3E%3Cpolygon points='0,0 30,21 0,42' fill='%23004b93'/%3E%3C/svg%3E\")";

export default function LangSwitch({ className = "", size = "sm" }) {
  const { lang, chooseLang } = useLang();
  const es = lang === "es";
  const pill = size === "lg" ? "h-11 px-3 text-[13px]" : "h-7 px-2.5 text-[11px]";

  return (
    <div
      role="group"
      aria-label={es ? "Idioma del sitio" : "Site language"}
      className={`inline-flex items-center gap-0.5 rounded-full border border-black/[0.10] bg-white p-0.5 dark:border-white/[0.14] dark:bg-[#24221e] ${className}`}
    >
      <button
        type="button"
        onClick={() => chooseLang("es")}
        aria-pressed={es}
        className={`flex items-center gap-1.5 rounded-full font-black tracking-[0.02em] transition-colors ${pill} ${
          es
            ? "bg-[#c62e2a] text-white shadow-[0_2px_8px_rgba(198,46,42,0.32)]"
            : "text-[#55534e] hover:bg-black/[0.05] dark:text-white/70 dark:hover:bg-white/10"
        }`}
      >
        <span
          aria-hidden="true"
          className="h-[9px] w-[13px] rounded-[1px] bg-cover bg-center ring-1 ring-black/15"
          style={{ backgroundImage: FLAG }}
        />
        Español
      </button>
      <button
        type="button"
        onClick={() => chooseLang("en")}
        aria-pressed={!es}
        className={`flex items-center gap-1.5 rounded-full font-black tracking-[0.02em] transition-colors ${pill} ${
          !es
            ? "bg-[#c62e2a] text-white shadow-[0_2px_8px_rgba(198,46,42,0.32)]"
            : "text-[#55534e] hover:bg-black/[0.05] dark:text-white/70 dark:hover:bg-white/10"
        }`}
      >
        English
      </button>
    </div>
  );
}